import HttpService from '@src/utils/http';
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
let http = new HttpService();

export const bindInviteCode = async (data) => {
  let res = await http.post('/activity/activity-invite/bindInviteCode', data);
  return res;
}
export const getInviteRelation = async (data) => {
  let res = await http.get('/activity/activity-invite/getInviteRelation', data);
  if (res.code === '2000') {
    return res.data;
  } else if (res.code === '2001') {
    JsBridge.doLogin();
  }
  return null;
}

export const getInviteReward = async (data) => {
  let res = await http.get('/activity/activity-invite/getInviteReward', data);
  return res;
}

export const getInviteActivityInfoByActId = async (data) => {
  let res = await http.get('/activity/activity-invite/getInviteActivityInfoByActId', data);
  if (res.code === '2000') {
    return res
  } else if (res.code === 'failed' && res.message === 'Network Error') {
    return res
  }
  return null;
}


// WEBPACK FOOTER //
// ./src/pages/inviteCodePage/scripts/services.js